export const USER_TYPE_BUYER = "Buyer";
export const USER_TYPE_SELLER = "Seller";
export const USER_TYPE_ADMIN = "Admin";
export const USER_PROFILE_STATUS_CREATED = "created";
export const USER_PROFILE_STATUS_NEW = "new";
export const USER_ACTION_ACCEPT = "accept_user";
export const USER_ACTION_REJECT = "reject_user";
